/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyTypeCardIcon20Regular = forwardRef('MoneyTypeCardIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12.5 8.25a.75.75 0 1 1 0-1.5h2a.75.75 0 1 1 0 1.5h-2Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.999 7.251a3.25 3.25 0 0 1 3.25-3.25h9.502a3.25 3.25 0 0 1 3.25 3.25v5.498a3.25 3.25 0 0 1-3.25 3.25H5.25a3.25 3.25 0 0 1-3.25-3.25V7.25Zm3.25-1.75a1.75 1.75 0 0 0-1.75 1.75v3.75H16.5V7.25a1.75 1.75 0 0 0-1.75-1.75H5.25Zm0 8.998A1.75 1.75 0 0 1 3.516 13h12.967a1.75 1.75 0 0 1-1.732 1.499H5.25Z" })));
});
